var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.18625 4.18632C2.41669 5.95587 2.41669 8.80394 2.41669 14.5001C2.41669 20.1962 2.41669 23.0443 4.18625 24.8138C5.95581 26.5834 8.80388 26.5834 14.5 26.5834C20.1961 26.5834 23.0443 26.5834 24.8137 24.8138C26.5834 23.0443 26.5834 20.1962 26.5834 14.5001C26.5834 8.80394 26.5834 5.95587 24.8137 4.18632C23.0443 2.41675 20.1961 2.41675 14.5 2.41675C8.80388 2.41675 5.95581 2.41675 4.18625 4.18632Z",
    fill: "#4D53E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 14.5001C16.9167 13.8623 16.2767 13.4322 14.9969 12.5719C13.6995 11.7 13.0507 11.264 12.567 11.5842C12.0833 11.9043 12.0833 12.7695 12.0833 14.5001C12.0833 16.2307 12.0833 17.0959 12.567 17.416C13.0507 17.7361 13.6995 17.3002 14.9969 16.4282C16.2767 15.568 16.9167 15.1378 16.9167 14.5001Z",
    fill: "#4D53E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55181 7.55217H2.6842C2.91893 6.07471 3.35942 5.01286 4.18596 4.18632C5.01249 3.35977 6.07434 2.9193 7.55181 2.68457V7.55217Z",
    fill: "#4D53E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3152 7.55217C26.0805 6.07471 25.64 5.01286 24.8135 4.18632C23.987 3.35977 22.9251 2.9193 21.4477 2.68457V7.55217H26.3152Z",
    fill: "#4D53E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5827 13.5939C26.5811 11.9431 26.5705 10.5503 26.4999 9.36475H21.4477V13.5939H26.5827Z",
    fill: "#4D53E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8135 24.8139C23.987 25.6404 22.9251 26.0809 21.4477 26.3156V21.448H26.3152C26.0805 22.9255 25.64 23.9873 24.8135 24.8139Z",
    fill: "#4D53E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5827 15.4062C26.5811 17.0571 26.5705 18.4499 26.4999 19.6354H21.4477V15.4062H26.5827Z",
    fill: "#4D53E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55181 21.448V26.3156C6.07434 26.0809 5.01249 25.6404 4.18596 24.8139C3.35941 23.9873 2.91893 22.9255 2.6842 21.448H7.55181Z",
    fill: "#4D53E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55181 19.6354H2.49946C2.42895 18.4499 2.41829 17.0571 2.41669 15.4062H7.55181V19.6354Z",
    fill: "#4D53E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55181 13.5939H2.41669C2.41829 11.9431 2.42895 10.5503 2.49946 9.36475H7.55181V13.5939Z",
    fill: "#4D53E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFrame);
export default __webpack_public_path__ + "static/media/video-frame.654c20270826c2c46ee333c22fc2ffe8.svg";
export { ForwardRef as ReactComponent };